import { useQuery } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { labFieldKeys } from '../constants';

export const useLabFieldValues = () => {
  return useQuery<string[], Error>({
    queryKey: labFieldKeys.all,
    queryFn: async () => {
      const response = await bffApiClient.get<string[]>(
        '/api/lab-field/values'
      );
      return response.data;
    },
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000
  });
};
